import {
  createContext,
  lazy,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

const InitialSetUpContent = lazy(() => import('./content.initial-setup'));

interface InitialSetUpContextType {
  initialSetupModule?: string;
  setInitialSetupModule: (initialSetupModule?: string) => void;
}

// Create the context with an empty initial state
const InitialSetUpContext = createContext<InitialSetUpContextType | undefined>(
  undefined,
);

export const InitialSetUpProvider = ({ children }: { children: ReactNode }) => {
  const [initialSetupModule, setInitialSetupModule] = useState<string>();

  const handleSetContext = useCallback((module?: string) => {
    setInitialSetupModule(module);
  }, []);

  return (
    <InitialSetUpContext.Provider
      value={{ initialSetupModule, setInitialSetupModule: handleSetContext }}
    >
      {children}
    </InitialSetUpContext.Provider>
  );
};

export const useInitialSetupContext = () => {
  const initialSetupContext = useContext(InitialSetUpContext);

  if (!initialSetupContext) {
    throw new Error(
      'useinitialSetupContext must be used within a initialSetupProvider',
    );
  }

  return initialSetupContext;
};

const InitialSetup = () => {
  return <InitialSetUpContent />;
};

export default InitialSetup;
